var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStatsView = function SvgStatsView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.19 3.5v1.536h2.755l-4.29 4.291-3.073-3.072L.43 11.407l1.086 1.086 4.066-4.066 3.072 3.072 5.377-5.377v2.755h1.537V3.5H10.19Z",
    fill: "#757D8A"
  })));
};
export { SvgStatsView as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjE5MDYgMy41VjUuMDM2M0gxMi45NDUyTDguNjU0MjcgOS4zMjcxOUw1LjU4MTY3IDYuMjU0NTlMMC40Mjk2ODggMTEuNDA2NkwxLjUxNTg1IDEyLjQ5MjdMNS41ODE2NyA4LjQyNjkyTDguNjU0MjcgMTEuNDk5NUwxNC4wMzEzIDYuMTIyNDZWOC44NzcwNUgxNS41Njc2VjMuNUgxMC4xOTA2WiIgZmlsbD0iIzc1N0Q4QSIvPgo8L3N2Zz4K";